import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import EditIcon from '@atlaskit/icon/core/migration/edit';
import { messages } from '../../../../../messages';
import Action from '../action';
var EditAction = function EditAction(props) {
  return /*#__PURE__*/React.createElement(Action, _extends({
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.edit),
    icon: /*#__PURE__*/React.createElement(EditIcon, {
      color: "currentColor",
      spacing: "spacious",
      label: "Edit"
    }),
    testId: "smart-action-edit-action",
    tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, messages.edit)
  }, props));
};
export default EditAction;